const storeManager = [
  {
    path: '/store-manager',
    name: 'store-manager',
    component: () => import('@/views/wxapp/store-manager'),
    redirect: '/store-manager/home',
    meta: {
      title: '店长'
    },
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/wxapp/store-manager/home'),
        // redirect: 'workbench',
        meta: {
          title: '店长'
        },
        children: [
          {
            path: 'workbench',
            name: 'store-manager_workbench',
            component: () => import('@/views/wxapp/store-manager/workbench'),
            meta: {
              title: '工作台'
            }
          },
          {
            path: 'business-data',
            name: 'store-manager_business-data',
            component: () => import('@/views/wxapp/store-manager/business-data'),
            meta: {
              title: '业务数据看板'
            }
          },
          {
            path: 'customer-list',
            name: 'storeManagerCustomerList',
            component: () => import('@/views/wxapp/service-system/list'),
            meta: {
              title: '我的用户'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/distribution',
    name: 'store-manager_distribution',
    component: () => import('@/views/wxapp/store-manager/workbench/distribution'),
    meta: {
      title: '上门待分配'
    }
  },
  {
    path: '/to-allocate',
    name: 'ToAllocate',
    component: () => import('@/views/wxapp/store-manager/workbench/to-allocate'),
    meta: {
      title: '上门待分配'
    }
  },
  {
    path: '/holding-status',
    name: 'HoldingStatus',
    component: () => import('@/views/wxapp/store-manager/workbench/holding-status'),
    meta: {
      title: '持单情况'
    }
  },
  {
    path: '/holding-status-list',
    name: 'HoldingStatusList',
    component: () => import('@/views/wxapp/store-manager/workbench/holding-status/list'),
    meta: {
      title: '持单情况'
    }
  },
  {
    path: '/today-store',
    name: 'TodayStore',
    component: () => import('@/views/wxapp/store-manager/workbench/today-store'),
    meta: {
      title: '今日到访'
    }
  },
  {
    path: '/personnel',
    name: 'personnel',
    component: () => import('@/views/wxapp/store-manager/workbench/personnel'),
    meta: {
      title: '人员到岗'
    }
  },
  {
    path: '/high-seas-pool',
    name: 'HighSeasPool',
    component: () => import('@/views/wxapp/store-manager/workbench/internationalWater/highSeasPool'),
    meta: {
      title: '公海池'
    }
  },
  {
    path: '/follow-high-seas-pool',
    name: 'FollowHighSeasPool',
    component: () => import('@/views/wxapp/store-manager/workbench/internationalWater/followHighSeasPool'),
    meta: {
      title: '公海池预面谈跟进'
    }
  },
  {
    path: '/follow-high-details',
    name: 'FollowHighDetails',
    component: () => import('@/views/wxapp/store-manager/workbench/internationalWater/followHighDetails'),
    meta: {
      title: '公海池详情'
    }
  }
]
export default storeManager
